<div class="pia-attachmentsBlock" *ngIf="attachments">
  <p>{{ "pia.attachments.title" | translate }}</p>

  <ng-container *ngIf="attachments.length > 0; else noAttachments">
    <app-attachment-item
      [editMode]="editMode"
      *ngFor="let attachment of attachments; let i = index"
      [attachment]="attachment"
      (deleted)="onDeleted($event)"
      [isPreview]="isPreview"
      [pia]="pia"
    >
    </app-attachment-item>
  </ng-container>
  <ng-template #noAttachments>
    <p>
      <small>{{ "pia.attachments.no_attachment" | translate }}</small>
    </p>
  </ng-template>

  <form
    *ngIf="!isPreview && attachments"
    enctype="multipart/form-data"
    [formGroup]="attachmentForm"
  >
    <input
      type="file"
      formControlName="attachment_file"
      id="attachment_file"
      (change)="uploadAttachement($event)"
      class="hide"
    />
    <button
      class="pia-attachmentsBlock-addBtn btn"
      *ngIf="
        ['author', 'validator', 'evaluator'].indexOf(editMode[0]) >= 0 ||
        editMode === 'local'
      "
      [disabled]="loading"
      [ngClass]="{ hide: !dispplayAttachmentButton }"
      type="button"
      (click)="addAttachment()"
    >
      <ng-container *ngIf="!loading; else loadingElse">
        <span class="pia-icons pia-icon-add"></span>
        {{ "pia.attachments.add" | translate }}
      </ng-container>
      <ng-template #loadingElse>
        {{ "pia.attachments.loading" | translate }}
      </ng-template>
    </button>
  </form>
</div>
